import React from 'react'
import { clearAuthStorage, getStoredJWT, setStoredJWT } from '../utils/helpers/authStorage'

type IdNamePair = {
  id: number | undefined
  name?: string
}

export type UserState = {
  id?: number
  name?: string
  clientIds?: number[]
}

export type JWT = {
  userId?: number
  clientId?: number
  clientIds?: number[]
  issuer?: string
  permissions?: string
  iat?: number
  exp?: number
}

type AppState = {
  client: IdNamePair
  user: UserState
  jwt: JWT
}

type Action = {
  type: string
  // TODO add generic
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any
}

type AppContextValue = {
  appState: AppState
  appReducer: React.Dispatch<Action>
}

export function jwtExpires(jwt?: JWT): number {
  if (!jwt) return 0
  return jwt.exp && jwt.iat ? jwt.exp - jwt.iat : 7 * 24 * 60 * 60 // 1 week default
}

const defaultJWT: JWT = getStoredJWT() || {}
const clientId = defaultJWT.clientId
const clientIds = defaultJWT.clientIds
const userId = defaultJWT.userId
export const defaultAppState: AppState = {
  client: {
    id: clientId,
  },
  user: {
    id: userId,
    clientIds,
  },
  jwt: defaultJWT,
}

export function appStateReducer(appState: AppState, action: Action): AppState {
  const { type, payload } = action

  switch (type) {
    case 'client':
      return { ...appState, client: payload }
    case 'user':
      return { ...appState, user: payload }
    case 'jwt':
      return updateJWT(appState, payload)
    default:
      throw new Error()
  }
}

const defaultValue: AppContextValue = {
  appState: defaultAppState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appReducer: ({ type, payload }) => {
    return
  },
}

function updateJWT(appState: AppState, newJWT: JWT | undefined): AppState {
  const clientId = newJWT?.clientId
  const clientIds = newJWT?.clientIds
  const userId = newJWT?.userId

  if (newJWT) setStoredJWT(newJWT)
  else clearAuthStorage()
  return {
    client: {
      ...appState.client,
      id: clientId,
    },
    user: {
      ...appState.user,
      id: userId,
      clientIds,
    },
    jwt: newJWT || {},
  }
}

const AppContext = React.createContext(defaultValue)

export default AppContext
